export const getLocale = () => {
  const bodyElement = document.getElementsByTagName('body')[0]
  const bodyLocale = bodyElement.attributes['data-locale']
  if (!bodyLocale) {
    return 'en'
  }
  const locale = bodyLocale.value
  return locale === 'cz' ? 'cs' : locale
}
